export const COLORS = {
  PINK_200: '#EC477B',
  PINK_210: '#FF4882',
  PINK_300: '#FF77A2',
  PINK_100: '#EA4579',
  WHITE: '#FFFFFF',
  GRAY_500: '#E7E7E7',
  GRAY_400: '#B7B7B7',
  GRAY_300: '#858585',
  GRAY_200: '#737373',
  GRAY_050: '#5C5C5C',
  BLACK_100: '#1C1C1C',
  BLACK_200: '#2F2F2F',
  BACKGROUND: '#4D4D4D',
  RED_100: '#EA4545',
  BLUE_100: '#0078D4',
};
